import React, { useState } from "react";
import { Link } from "react-router-dom";
import AnimatedPageContainer from "../../assets/containers/AnimatedPageContainer";
import Loading from "../../assets/containers/loadingDialog";
import NoResultAlter from "../../assets/components/UI/NoResultAlter";
import listStyles from "../../assets/components/questListElement/styles/style.module.css";
import styles from "./styles.module.css";
import useReportCardRequest from "./useReportCardRequest";
import ReportCardPagination from "./ReportCardPagination";
import ReportCardFilters from "./ReportCardFilters";
import CalendarIcon from "../../assets/images/icons/calendar.svg";

export default function ReportCards() {
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState("New");
  const { data, loading, error, retry } = useReportCardRequest("/reportcard/getuser", page, filter);
  return (
    <AnimatedPageContainer>
      <div className="customContainer mt-4" dir="rtl">
        <ReportCardFilters selected={filter} onChange={value => {
          setFilter(value);
          setPage(1);
        }} />
        {loading ? <div className="w-100 d-flex justify-content-center py-5 my-5" role="status" aria-label="در حال دریافت کارنامه‌ها"><Loading size={30} /></div>
          : error ? <div className={styles.status} role="alert"><p>{error}</p><button className={styles.button} onClick={retry}>تلاش مجدد</button></div>
          : data?.docs.length ? <>
            {data.docs.map(card => (
              <Link key={card._id} to={`/reportcard/${card._id}`} className={`${listStyles.questListElement} ${styles.listItem}`}>
                <div className={listStyles.diamondImgContainer}><img src={CalendarIcon} alt="" /></div>
                <div className={listStyles.contentContainer}>
                  <p>{card.title}</p>
                  <p>{card.subtitle}</p>
                </div>
              </Link>
            ))}
            <ReportCardPagination page={page} totalPages={data.totalPages} onChange={setPage} />
          </> : <NoResultAlter className="w-100 py-5 my-5" text="کارنامه‌ای برای شما ثبت نشده است" />}
      </div>
    </AnimatedPageContainer>
  );
}
